<script>
    import app from '../../stores/app';

    export let user = null;
    export let userId = null;
    export let name = '';
    export let color = '';

    export let sm = false;
    export let md = false;
    export let xl = false;
    export let pointer = false;

    let initials = '';
    let bgColor = '';

    $: {
        if (userId && !user) {
            user = app.getUser(userId);
        }

        if (user) {
            initials = user.name.split(' ').map(word => word[0]).join('').toUpperCase();
            bgColor = user.color ? user.color : 'efefef';
        } else if (name) {
            initials = name.split(' ').map(word => word[0]).join('').toUpperCase();
            bgColor = color ? color : 'efefef';
        } else {
            initials = '';
            bgColor = 'efefef';
        }
    }
</script>

<span class="initials" class:sm={sm} class:md={md} class:xl={xl} class:pointer={pointer} style="background: #{bgColor};">
    { initials }
</span>

<style>
    .initials {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 30px;
        height: 30px;
        color: white;
        background: #efefef;
        border-radius: 50%;
    }

    .initials.pointer {
        cursor: pointer;
    }

    .initials.sm {
        width: 18px;
        height: 18px;
        font-size: 8px;
    }

    .initials.md {
        width: 24px;
        height: 24px;
        font-size: 10px;
    }

    .initials.xl {
        width: 40px;
        height: 40px;
        font-size: 16px;
    }
</style>